<div class="container">
    <div *ngIf="isLoading" class="row center">
       <div class="spinner-border text-danger" role="status">
          <span class="sr-only">Loading...</span>
       </div>
    </div>
    <div *ngIf="!isLoading" class="row">
       <div class="col-lg-12 col-md-12 col-xs-12">
          <div class="col-md-9 col-xs-9 mgb-10">
             <h2>Match List</h2>
          </div>
          <div class="col-md-12 col-xs-12">
             <div class="table-responsive">
                <table class="table table-bordered table-striped">
                   <thead>
                      <tr>
                         <th class="center pd1p">#</th>
                         <th>Event ID</th>
                         <th>Event Name</th>
                         <th>Competition Name</th>
                         <th>Sport Name</th>                
                         <th>Open Date</th>
                         <th>Status</th>
                         <th>Action</th>
                         <th *ngIf="level == '1'">RollBack</th>
                      </tr>
                   </thead>
                   <tbody>
                      <tr *ngFor="let data of match; let i = index">
                         <td class="center pd1p">{{ i+1 }}</td>
                         <td>{{ data.eventId }}</td>
                         <td>{{ data.eventName }}</td>
                         <td>{{ data.competitionName }}</td>
                         <td><span class="badge badgeback">{{ data.sportName }}</span></td>            
                         <td>{{ data.openDate }}</td>
                         <td>{{ data.isResult }}</td>
                         <td><a routerLink="/match-activities/{{ data.eventId }}">
                            <button id="btn{{ i }}" class="btn btn-danger fbtn">Show Activities</button>
                         </a></td>
                         <td *ngIf="level == '1'">
                           <button [disabled]="!data.isResult" id="mbtn{{ i }}" (click)="rollbackMatch(i, data.eventId)" class="btn btn-primary">
                             RollBack Match
                           </button>
                           <div id="mprocess{{ i }}" class="row center" style="margin-top:5px;display:none;">
                             <div class="spinner-border2 text-danger" role="status">
                               <span class="sr-only">Loading...</span>
                             </div>
                           </div>
                         </td>
                      </tr>
                   </tbody>
                </table>
             </div>
          </div>
       </div>
    </div>
 </div>